<template>
  <el-scrollbar ref="scroll" wrap-class="scrollbar-wrapper" >
    <div class="about">
      <p class="about-row">
        <i v-if="!sidebarCollapse" class="el-icon-time" />
        <span v-if="!sidebarCollapse">{{ time | formatTime('dd/MM/yyyy ') }}</span>
        <span>{{ time | formatTime('hh:mm') }}</span>
      </p>
      <p class="about-row"><el-tag size="mini" type="info" effect="dark">V{{version}}</el-tag></p>
    </div>
    <el-menu
      :show-timeout="200"
      :default-active="$route.name"
      :collapse="sidebarCollapse"
      :unique-opened="true"
      mode="vertical"
      class="app-left-menu"
      @open="updateScroll"
      @close="updateScroll"
    >
      <sidebar-item v-for="route in realPermissionRouters" :key="route.name" :item="route" :base-path="route.name"/>
    </el-menu>
  </el-scrollbar>
</template>
<script>
import { mapGetters } from 'vuex'
import SidebarItem from './SidebarItem'

export default {
  components: { SidebarItem },
  data(){
    return {
      interval: null,
      time: new Date(),
      version: process.env.VUE_APP_VERSION
    }
  },
  created() {
    this.interval = setInterval(() => {
      this.time = new Date()
    })
  },
  destroyed() {
    clearInterval(this.interval)
  },
  filters: {
    formatTime(date, fmt) {
      return date.format(fmt)
    }
  },
  computed: {
    ...mapGetters([
      'realPermissionRouters',
      'sidebarCollapse'
    ])
  },
  methods: {
    updateScroll: function() {
      // 手动触发一下scroll的更新
      setTimeout(() => {
        this.$refs.scroll.update()
      }, 300)
    }
  }
}
</script>
<style scoped>
.about {
  text-align: center;
  color: #fff;
  margin-top: 10px;
}
.about-row {
  margin: 5px 0;
}
</style>
